module.exports = __webpack_public_path__ + "static/img/brees-2007-slide-2.e480dfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-slide-2.jpg
// module id = bhcy
// module chunks = 1